import React from 'react';

export const LayersIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24" 
        strokeWidth={1.5} 
        stroke="currentColor" 
        {...props}
    >
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 12.75l-4.5-4.5m4.5 4.5l4.5-4.5m-4.5 4.5v6m-4.5-8.25v6a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-6" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 9.75h16.5" />
    </svg>
);